export default function editCompany(el) {
    return {
        dom_el: el,
        company: null,
        company_id: '',
        is_loading: false,
        init() {
            this.$watch('company_id', (id) => {
                if (id) this.loadCompany(id);
            });

            document.addEventListener('click', (e) => {
                const target = e.target.closest('.edit-company');
                if (target) {
                    e.preventDefault();
                    this.company_id = target.dataset.companyId;
                }
            });

            this.$watch('company', () => this.initAddresses());
        },
        loadCompany(id) {
            this.is_loading = true;
            const formData = new FormData();
            formData.append('action', 'kitan_company_data');
            formData.append('nonce', main.nonce);
            formData.append('company_id', id);

            fetch(main.ajaxUrl, {
                method: 'POST',
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success && data.data.company) {
                        this.company = data.data.company;
                        // Ждем обновления DOM перед снятием флага
                        this.$nextTick(() => {
                            this.is_loading = false;
                        });
                    }
                })
                .catch(error => console.error('Error:', error));
        },
        save() {
            if (this.is_loading) return;
            this.is_loading = true;

            const formData = new FormData(this.$refs.companyForm);
            formData.append('action', 'kitan_update_company');
            formData.append('nonce', main.nonce);
            // company_id уже есть в форме, FormData его подхватит

            fetch(main.ajaxUrl, {
                method: 'POST',
                body: formData
            })
                .then(r => r.json())
                .then(res => {
                    if (res.success) {
                        this.close();
                        window.location.reload();
                    } else {
                        console.error('Помилка збереження');
                        // Можно добавить логику отката значения при ошибке
                    }
                })
                .finally(() => {
                    this.is_loading = false;
                });
        },
        close() {
            this.company = null;
            this.company_id = '';
        },
        downloadContract() {
            if (!this.company_id || !this.company?.can_download_contract) {
                return;
            }
            const url = new URL(main.ajaxUrl);
            url.searchParams.set('action', 'kitan_sync_bas_download_my_company_contract');
            url.searchParams.set('nonce', main.nonce);
            url.searchParams.set('company_id', this.company_id);
            window.location.href = url.toString();
        },
        initAddresses() {
            if (this.company) {
                if (!this.company.addresses) {
                    this.company.addresses = [];
                } else {
                    // Преобразуем строки адресов в объекты для редактирования
                    const needsFormatting = this.company.addresses.some(a => typeof a !== 'object');
                    if (needsFormatting) {
                        this.company.addresses = this.company.addresses.map(a => typeof a === 'object' ? a : { value: a, edit: false });
                    }
                }
            }
        },
        addAddress() {
            if (!this.company.addresses) this.company.addresses = [];
            this.company.addresses.push({ value: '', edit: true });
        },

        removeAddress(index) {
            this.company.addresses.splice(index, 1);
        },
        removeFile(index) {
            if (this.company.company_files && index in this.company.company_files) {
                const newFiles = { ...this.company.company_files };
                delete newFiles[index];
                this.company.company_files = newFiles;
            }
        },
        uploadFile(e) {
            const files = e.target.files;
            if (!files.length) return;

            this.is_loading = true;
            const formData = new FormData();
            formData.append('action', 'kitan_add_company_file');
            formData.append('nonce', main.nonce);
            formData.append('company_id', this.company_id);
            formData.append('file', files[0]);

            fetch(main.ajaxUrl, {
                method: 'POST',
                body: formData
            })
                .then(r => r.json())
                .then(res => {
                    if (res.success) {
                        this.loadCompany(this.company_id);
                    } else {
                        alert(res.data || 'Помилка завантаження');
                    }
                })
                .catch(error => console.error('Error:', error))
                .finally(() => {
                    this.is_loading = false;
                    e.target.value = '';
                });
        }
    };
}
